import { createReducer } from 'redux-create-reducer';
import { Audience } from 'components/audience/models/segmentModel';
import {
    AudiencesCreateAction,
    AudiencesGetErrorAction,
    AudiencesGetListAction,
    AudiencesRequestAction,
    AudiencesUpdateAction
} from './audiencesActions';
import { AudiencesActionTypes } from './audiencesActionTypes';

export interface AudiencesState {
    isLoading: boolean;
    audiences: Audience[];
}

type AudiencesAction =
    | AudiencesRequestAction
    | AudiencesGetErrorAction
    | AudiencesGetListAction
    | AudiencesCreateAction
    | AudiencesUpdateAction;

type AudienceActionHandlers = {
    [key in AudiencesActionTypes]: (state: AudiencesState, action?: AudiencesAction) => AudiencesState;
};

export const initialState: AudiencesState = {
    audiences: [],
    isLoading: true
};

const actionHandlers: AudienceActionHandlers = {
    [AudiencesActionTypes.START_REQUEST]: state => ({ ...state, isLoading: true }),
    [AudiencesActionTypes.END_REQUEST]: state => ({ ...state, isLoading: false }),
    [AudiencesActionTypes.GET_AUDIENCES_ERROR]: state => ({ ...state, audiences: [] }),
    [AudiencesActionTypes.GET_AUDIENCES_SUCCESS]: (
        state,
        { audiences, summary }: AudiencesGetListAction
    ) => ({ ...state, summary, audiences }),
    [AudiencesActionTypes.LOAD_AUDIENCES_SUCCESS]: (
        state,
        { audiences, summary }: AudiencesGetListAction
    ) => ({
        ...state,
        summary,
        audiences: [...state.audiences, ...audiences]
    }),
    [AudiencesActionTypes.CREATE_AUDIENCE_SUCCESS]: (state, { audience }: AudiencesCreateAction) => ({
        ...state,
        audiences: [audience, ...state.audiences]
    }),
    [AudiencesActionTypes.UPDATE_AUDIENCE_SUCCESS]: (state, { audience }: AudiencesUpdateAction) => ({
        ...state,
        audiences: state.audiences.map(item =>
            item._id === audience._id ? { count: item.count, metrics: item.metrics, ...audience } : item
        )
    })
};

export default createReducer(initialState, actionHandlers);
